import { useEffect } from 'react';
import '../../styles/inputs/aiSelectInput.scss';

interface SelectOptionArr {
  OptionValue: string;
  OptionName: string;
  OptionDisabled?: boolean;
}

interface Props {
  defaultValue: string;
  setSelect: (input: string) => void;
  selectOptionArr: SelectOptionArr[];
  placeholder?: string;
  id: string;
  disabled?: boolean;
  required?: boolean;
  refreshButton?: {
    onClick: () => void;
    isLoading: boolean;
    icon: React.ReactNode;
  };
}

const AISelectInput: React.FC<Props> = ({
  defaultValue,
  setSelect,
  selectOptionArr,
  placeholder,
  id,
  disabled,
  required,
  refreshButton,
}) => {
  useEffect(() => {
    setSelect(defaultValue);
  }, [defaultValue]);

  function handleSelect(event: React.ChangeEvent<HTMLSelectElement>) {
    setSelect(event.target.value);
  }

  return (
    <div className='aiSelectInput-outer'>
      <div className='aiSelectInput-label-container'>
        <label style={required ? { color: '#F00' } : {}} htmlFor={id}>
          {placeholder}
        </label>
        {refreshButton && (
          <button
            type='button'
            onClick={refreshButton.onClick}
            disabled={refreshButton.isLoading}
            className='aiSelectInput-refresh-button'
            title='Refresh'
          >
            {refreshButton.isLoading ? (
              <div className='aiSelectInput-refresh-icon aiSelectInput-refresh-icon--loading'>
                {refreshButton.icon}
              </div>
            ) : (
              <>
                <span className='aiSelectInput-refresh-text'>Refresh</span>
                <div className='aiSelectInput-refresh-icon'>
                  {refreshButton.icon}
                </div>
              </>
            )}
          </button>
        )}
      </div>
      <div
        className='aiSelectInput'
        style={required ? { borderColor: '#F00' } : {}}
      >
        <select
          className='w-full peer border border-solid border-[#dbdbdb] rounded-lg  p-2 pb-1 outline-none focus:outline-none focus:border-[#cecece] transition-all duration-500 hover:border-[#cecece]'
          onChange={(e) => handleSelect(e)}
          defaultValue={defaultValue}
          value={defaultValue}
          id={id}
          disabled={disabled}
          required={required}
        >
          {selectOptionArr.map((selectOption, i) => {
            return (
              <option
                key={i}
                value={selectOption.OptionValue}
                disabled={selectOption.OptionDisabled}
              >
                {selectOption.OptionName}
              </option>
            );
          })}
        </select>
      </div>
      {/* <div className='aiSelectInput-validation-text'></div> */}
    </div>
  );
};

export default AISelectInput;
